import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getAutoPaidRepaymentdetails = async ({
  Page,
  PageSize,
  Reference,
  Aggregator_Id,
  DateRepaidFrom,
  DateRepaidTo,
  RepaymentStatus,
}) => {
  let queryParams = `?Page=${Page}&PageSize=${PageSize}`;
  if (Reference) {
    queryParams = `${queryParams}&Reference=${Reference}`;
  }
  if (Aggregator_Id) {
    queryParams = `${queryParams}&Aggregator_Id=${Aggregator_Id}`;
  }
  if (DateRepaidFrom) {
    queryParams = `${queryParams}&DateRepaidFrom=${DateRepaidFrom}`;
  }
  if (DateRepaidTo) {
    queryParams = `${queryParams}&DateRepaidTo=${DateRepaidTo}`;
  }
  if (RepaymentStatus) {
    queryParams = `${queryParams}&RepaymentStatus=${RepaymentStatus}`;
  }

  const data = await getDataWithDotNet(
    `${ajaxEndpoints.GETALLPAIDREPAYMENTDETAILS}${queryParams && queryParams}`
  );
  return data;
};

export default function useAutoPaidRepaymentdetails({
  Page,
  PageSize,
  Reference,
  Aggregator_Id,
  DateRepaidFrom,
  DateRepaidTo,
  RepaymentStatus,
}) {
  return useQuery(
    [
      {
        Page,
        PageSize,
        Reference,
        Aggregator_Id,
        DateRepaidFrom,
        DateRepaidTo,
        RepaymentStatus,
      },
      "getAutoPaidRepaymentdetails",
    ],
    getAutoPaidRepaymentdetails,
    {
      refetchOnWindowFocus: false,
    }
  );
}
